// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9c25c93e","498":"5c1fa033","703":"ec167eab","787":"b91dae35"}[chunkId] + ".chunk.js";
};